import { ActiveSelection, FabricObject, Point, util } from 'fabric'

const stablePoint = (object: FabricObject, selection: ActiveSelection | null) => {
  const objectTransform = util.saveObjectTransform(object)
  let objectPoint = new Point(objectTransform.left, objectTransform.top)
  if (selection){
    objectPoint = objectPoint.transform(selection.calcOwnMatrix())
  }
  return objectPoint
}

export {
  stablePoint
}